"use strict";

$(function () {
  $('.js-print').on('click', function (e) {
    e.preventDefault();
    window.print();
  });
});